import { SubInfoItem } from "./SubInfoItem";

import { IconWithBorder, Button } from "components";
import { useIntl } from "react-intl";
import { HiLocationMarker } from "react-icons/hi";

import "./DoctorInfo.scss";
import { Rating } from "components/Rating";

import { useWindowSize } from "rooks";
import { IoLanguageOutline } from "react-icons/io5";
import { generateImageLink } from "utils";
import doctorDefaultMale from "assets/icons/doctor-default-male.png";
import doctorDefaultFemale from "assets/icons/doctor-default-female.png";

export type DoctorInfoProps = {
  title: string;
  subtitle: string;
  languages: string[];
  branches: any[];
  image: string;
  rating?: number;
  rating_quantity?: number;
  onClick: () => void;
  gender: string;
};

export const DoctorInfo = ({
  title,
  subtitle,
  languages,
  branches,
  image,
  rating,
  rating_quantity,
  onClick,
  gender
}: DoctorInfoProps) => {
  const { innerWidth } = useWindowSize();
  const { formatMessage } = useIntl();

  let doctorImage = generateImageLink({ imageId: image });

  if (!image && gender === "male") {
    doctorImage = doctorDefaultMale;
  } else if (!image && gender === "female") {
    doctorImage = doctorDefaultFemale;
  }

  return (
    <div className="doctor-info">
      <div className="doctor-info__content">
        <div className="doctor-info__img-wrapper">
          <img
            alt="doctor-info"
            className="doctor-info__img"
            src={doctorImage}
            loading="lazy"
          />
        </div>
        <div className="text-content">
          <div className="text-content__title">{title}</div>
          <div className="text-content__subtitle">{subtitle}</div>
          <Rating
            point={rating ? rating.toString() : "0"}
            quantity={rating_quantity ? rating_quantity.toString() : "0"}
          />
          {innerWidth && innerWidth <= 1200 && (
            <Button className="doctor-info__button" onClick={onClick}>
              {formatMessage({
                id: "doctors.modal.appointment",
                defaultMessage: "_Appointment_",
              })}
            </Button>
          )}
          <div className="text-content__subinfo">
            <SubInfoItem
              title={formatMessage({
                id: "doctors.modal.branch",
                defaultMessage: "_Branch_",
              })}
              content={branches
                ?.map((branch) => {
                  return branch?.title;
                })
                .join(branches?.length > 0 ? ", " : "")}
            >
              <IconWithBorder
                size="large"
                className="text-content__subinfo--icon"
              >
                <HiLocationMarker />
              </IconWithBorder>
            </SubInfoItem>
            <SubInfoItem
              title={formatMessage({
                id: "doctors.modal.languages",
                defaultMessage: "_Languages_",
              })}
              content={
                <div className="doctor-info__languages">
                 {languages?.map((language, i) => {
  const safeLanguage = language.replace("-", "_"); // 🛡️ Fix dashes
  return `${formatMessage(
    {
      id: "languages.by-short",
      defaultMessage: "_languages_"
    },
    { language: safeLanguage }
  )}${i !== languages.length - 1 ? "," : ""} `;
})}

                </div>
              }
            >
              <IconWithBorder
                size="large"
                className="text-content__subinfo--icon"
              >
                <IoLanguageOutline />
              </IconWithBorder>
            </SubInfoItem>
          </div>
        </div>
      </div>
      {innerWidth && innerWidth > 1200 && (
        <Button className="doctor-info__button" onClick={onClick}>
          {formatMessage({
                id: "doctors.modal.appointment",
                defaultMessage: "_Appointment_",
              })}
        </Button>
      )}
    </div>
  );
};
